import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, Button, Box, useClipboard, ModalCloseButton, ModalBody } from '@chakra-ui/react';
import { mdiCheck, mdiContentCopy } from '@mdi/js';
import { Icon } from '@mdi/react';
import { formatErrorsToText, useErrorState } from '../state/useErrorState';
import ErrorMessageRow from './ErrorMessageRow';
import { SupportEmail } from '../utils/surveyStatusSchemas';

const ErrorModal = ({ shouldRefresh }: { shouldRefresh?: boolean }) => {
    const errors = useErrorState(state => Object.values(state.errors));
    const clearErrors = useErrorState(state => state.clearErrors);
    const emailHref = `mailto:${SupportEmail}`;

    const { hasCopied, onCopy } = useClipboard(formatErrorsToText(errors));

    return (
        <Modal closeOnOverlayClick={false} isOpen={errors.length > 0} onClose={clearErrors} size="xl">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader display="flex" justifyContent="flex-start" alignItems="center">
                    {errors.length} Error<span>{errors.length === 1 ? '' : 's'}</span>
                    <ModalCloseButton />
                </ModalHeader>
                <Box overflowY="auto" maxHeight="calc(80dvh - 7rem)">
                    {errors.map(error => (
                        <ModalBody key={error.id}>
                            <ErrorMessageRow defaultExpanded={errors && errors.length === 1} key={error.id} error={error} />
                        </ModalBody>
                    ))}
                </Box>
                <ModalBody>
                    Please{' '}
                    <a href={emailHref} style={{ textDecoration: 'underline' }}>
                        contact customer support
                    </a>{' '}
                    if you need additional assistance
                </ModalBody>
                <ModalFooter display="flex" justifyContent="space-between">
                    <Button
                        aria-label="Copy Error"
                        leftIcon={<Icon path={hasCopied ? mdiCheck : mdiContentCopy} size="1rem" />}
                        variant="ghost"
                        onClick={onCopy}
                        isDisabled={hasCopied}
                    >
                        {errors.length > 1 ? 'Copy All' : 'Copy Error'}
                    </Button>
                    <Button
                        onClick={() => {
                            clearErrors();
                            if (shouldRefresh) {
                                window.location.reload();
                            }
                        }}
                    >
                        {shouldRefresh ? 'Reload' : 'Close'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ErrorModal;
